module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-navbar",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('mt-navbar', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "1",
      "componentname": "navbar"
    }
  }, [_vm._v("\n      选项一\n      "), _c('mt-badge', {
    attrs: {
      "slot": "badge",
      "size": "normal",
      "padding": "3px",
      "color": "red"
    },
    slot: "badge"
  })], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "2",
      "componentname": "navbar"
    }
  }, [_vm._v("选项二")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "3",
      "componentname": "navbar"
    }
  }, [_vm._v("选项三")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "4",
      "componentname": "navbar"
    }
  }, [_vm._v("选项四")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "5",
      "componentname": "navbar"
    }
  }, [_vm._v("选项五")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "6",
      "componentname": "navbar"
    }
  }, [_vm._v("选项六")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_c('mt-cell', {
    attrs: {
      "title": "当前选中",
      "wrapperpaddingleft": "20px"
    }
  }, [_vm._v(_vm._s(_vm.selected))])], 1), _vm._v(" "), _c('mt-tab-container', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "1"
    }
  }, [_c('mt-cell-group', _vm._l((10), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '内容 ' + n,
        "wrapperpaddingleft": "20px"
      }
    })
  }))], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "2"
    }
  }, [_c('mt-cell-group', _vm._l((4), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '测试 ' + n,
        "wrapperpaddingleft": "20px"
      }
    })
  }))], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "3"
    }
  }, [_c('mt-cell-group', _vm._l((6), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '选项 ' + n,
        "wrapperpaddingleft": "20px"
      }
    })
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b5eb63","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/navbar.vue
// module id = 571
// module chunks = 0